export default __webpack_public_path__ + "static/media/3-pieces-lower-mantle.72234c3f.svg";